class GiftCardGuide {
  constructor(root) {
    this.root = root;
    this.toggle = root.querySelector('[data-gift-card-faq-toggle]');
    this.items = [...root.querySelectorAll('.gift-card-faq__group details')];

    if (!this.toggle || this.items.length === 0) return;

    this.toggle.hidden = false;
    this.toggle.addEventListener('click', () => this.toggleAll());
    this.items.forEach((item) => item.addEventListener('toggle', () => this.syncLabel()));
    this.syncLabel();
  }

  toggleAll() {
    const shouldOpen = !this.items.every((item) => item.open);
    this.items.forEach((item) => {
      item.open = shouldOpen;
    });
    this.syncLabel();
  }

  syncLabel() {
    const allOpen = this.items.every((item) => item.open);
    this.toggle.textContent = allOpen ? 'Collapse all' : 'Expand all';
    this.toggle.setAttribute('aria-expanded', String(allOpen));
  }
}

document.querySelectorAll('[data-gift-card-guide]').forEach((root) => new GiftCardGuide(root));
